// @flow
import React, { useRef, useEffect } from 'react';
import mapboxgl from 'mapbox-gl';

type MarkerProps = {
  map: any,
  place: any,
};

const Marker = ({ map, place }: MarkerProps) => {
  const markerRef = useRef();

  useEffect(() => {
    const marker = new mapboxgl.Marker(markerRef)
      .setLngLat([place.longitude, place.latitude])
      .addTo(map);

    return () => marker.remove();
  });

  return <div ref={markerRef} />;
};

type MarkersProps = {
  map: any,
  places: any,
};

const Markers = ({ map, places }: MarkersProps) => (
  <>
    {places &&
      places.map((place) => (
        <Marker key={place.name} map={map} place={place} />
      ))}
  </>
);

export default Markers;
